var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('BudgetPageToolbar',{attrs:{"title":_vm.$capitalize(_vm.$tc('model.products_claimed_title')),"backTo":{
          name: 'ProductPageData',
        },"newTo":{
          name: 'ProductNewCompensation',
        },"version-route-name":"ProductCompensationData","budget-versions":_vm.compensations}})],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }